/* unplugin-vue-components disabled */import script from "./DialogIsAdvertis.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogIsAdvertis.vue?vue&type=script&setup=true&lang=js"

import "./DialogIsAdvertis.vue?vue&type=style&index=0&id=65abb25c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65abb25c"]])

export default __exports__